"use client";
import { ReactNode, useEffect } from "react";

import BaseLayout from "../../layouts/BaseLayout";
import BlogHeader from "../components/BlogHeader";

const BlogLayout = ({ children }: BlogLayoutProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <BaseLayout>
      <BlogHeader />
      <main style={{ padding: "6rem 0" }}>{children}</main>
    </BaseLayout>
  );
};

interface BlogLayoutProps {
  children: ReactNode;
}

export default BlogLayout;
